
export const environment = {
    production: true,
    env: 'production',
    baseUrl:'https://aws-navendor-global-api.clickitapp.io',
  firebase : {
    apiKey: 'AIzaSyA0hHpwXvB0rgzib8dX3Ia540P_IJ7aiaI',
    authDomain: 'clickit-lafarge-prod.firebaseapp.com',
    databaseURL: 'undefined',
    projectId: 'clickit-lafarge-prod',
    storageBucket: 'clickit-lafarge-prod.firebasestorage.app',
    messagingSenderId: '1081734665959',
    appId: '1:1081734665959:web:8cd1bb3e234e8fb1ad7442',
    measurementId: 'G-MB01BJSK5Z',
    vapidKey: 'BHt1Uvln3cwzfzghZFiEAQBIuAepH5N0EGvhE8gnd-lfgx5goyZLndpxBmI8DFZx7V4ttZFr9B7Ux808L7MczbQ'
  },
  RECAPTCHA_SITE_KEY: '6Ld0AAAgAAAAABt-dNH9clRWzJ_BQZtuge0-pzRf',
  HEROKU_RELEASE_VERSION: '1.60.0'
};